const entrepriseInterface = {
  nom: "",
  adresse: "",
  offre: "",
  dateDebut: new Date().toISOString().slice(0, 10),
  dateExpiration: "",
  statutAbonnement: 1,
  historiqueModifications: [],
  heureOuverture: "",
  heureFermeture: "",
  tolerancePauseMinutes: 10,
};

export default entrepriseInterface;
